import * as moment from 'moment';
import app from 'apprun';

import lookupAuto from './lookupAuto.json';
import _,{lang} from './l10n';

const lookup = lookupAuto.en;

export function addOptions(lookupName, selectedId) {
  return lookup[lookupName].map(r => (
    <option value={r.id} selected={r.id == selectedId ? 'selected' : null}>
      {r.value}
    </option>
  ));
}

export function toggleNext(id) {
  document.getElementById(id).classList.toggle('collapsed');
}
interface IDictionary {
  [index: string]: boolean;
}

export function getLogFn(flag: boolean, css: string = ''): (any) => void {
  return flag
    ? function(obj: any) {
        if (typeof obj == 'string') {
          //console.log('%c' + obj, css);
        } else {
          //console.log(obj);
        }
      }
    : function(obj: any) {};
}

export function areRequiredFieldsAvailable(state, formName): boolean {
  let retVal: boolean = true;
  let errMsg = '';
  let errRequired: IDictionary = {};
  let requiredNodesList = document.getElementById(formName).querySelectorAll('[required]');
  let requiredNodesArray = Array.prototype.slice.call(requiredNodesList, 0);

  requiredNodesArray.forEach(element => {
    if (element.value.trim() == '') {
      retVal = false;
      errMsg += element.name + ' is required. ';
      errRequired[element.name] = true;
    } else {
      errRequired[element.name] = false;
    }
  });
  state.errRequired = errRequired;
  state.errMsg = errMsg;
  return retVal;
}

export function validateEmail(email): boolean {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function validatePhone(phone): boolean {
  var rePhone =  /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  var rePhoneExt =  /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})[-. Xx]?([0-9]+)$/;

  if(rePhone.test(phone)){
    return true;
  }else if(rePhoneExt.test(phone)){
    return true;
  }else
    return false;
}

export function validateDate(dateStr): boolean {
  return moment(dateStr, 'D-MMM-YYYY', true).isValid();
}
export function validatePostalCode(postalCode): boolean {
  var re = /^[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ] ?[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]$/;
  return re.test(String(postalCode.toUpperCase()));
}

export function validatePassword(password): boolean {
  var re = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$/;
  return re.test(String(password));
}


export function isValid(formName): boolean {
  //console.log('In isValid...');
  let retVal: boolean = true;

  let requiredNodesList = document.getElementById(formName).querySelectorAll('[data-validate]');
  let requiredNodesArray = Array.prototype.slice.call(requiredNodesList, 0);

  //console.log(requiredNodesArray);
  let validationSummary = "";

  requiredNodesArray.forEach(element => {
    //let errDiv = document.getElementById(element.id + 'ErrMsg') as HTMLDivElement;
    let localErr = "";
    //console.log(element.getAttribute('data-validate'));
    console.log(element.id+","  + element.value);

    if (element.value.trim() == '') {
      retVal = false;
      //errDiv.innerHTML = '* \'' + element.displayFieldName + '\' is required';      
      localErr      
      if(lang == 'fr-ca')
        localErr= '* \'' + element.displayFieldName + '\' est requis'; 
      else
        localErr= '* \'' + element.displayFieldName + '\' is required'; 
    } else if (element.getAttribute('data-validate') === 'Int' && element.value == 0) {
      retVal = false;

      if(lang == 'fr-ca')
        localErr= '* requis'; 
      else
        localErr = '* required';      
    } else if (element.getAttribute('data-validate') === 'Int-1' && element.value == -1) {
      retVal = false;

      if(lang == 'fr-ca')
        localErr= '* requis'; 
      else
        localErr = '* required';      

    } else if (element.getAttribute('data-validate') === 'PCode' && !validatePostalCode(element.value.trim())) {
      retVal = false;

      if(lang == 'fr-ca')
        localErr= '* code postal invalide'; 
      else
        localErr = '* invalid postal code';

    } else if (element.getAttribute('data-validate') === 'email' && !validateEmail(element.value.trim())) {
      retVal = false;

      if(lang == 'fr-ca')
        localErr= '* email invalide'; 
      else
        localErr = '* invalid email';

    } else if (element.getAttribute('data-validate') === 'Date' && !validateDate(element.value.trim())) {
      retVal = false;
      
      if(lang == 'fr-ca')
        localErr= '* date invalide'; 
      else
        localErr = '* invalid date';

    } else if (element.getAttribute('data-validate') === 'Phone' && !validatePhone(element.value.trim())) {
      retVal = false;
      
      if(lang == 'fr-ca')
        localErr= '* téléphone invalide'; 
      else
        localErr = '* invalid phone';

    } else if (element.getAttribute('data-validate') === 'PWD' && !validatePassword(element.value.trim())) {
      
      retVal = false;
      if(lang == 'fr-ca')
        localErr = '* contenir au moins six caractères, contenir au moins un chiffre (0-9), contenir au moins une minuscule (a-z), contenir au moins une majuscule (A-Z), contenir au moins un caractère spécial';
      else
        localErr = '* invalid password: Minimum six characters, at least one uppercase letter, one lowercase letter, one number and one special character.';

    } else {
      localErr = '';
    }

    if(localErr != ''){
      validationSummary += '<p>'+localErr+'</p>';
    }
    
  });

  let errSummaryDiv = document.getElementById(formName + 'ErrorSummary') as HTMLDivElement;
  
  if(validationSummary){
    errSummaryDiv.innerHTML = validationSummary;
    errSummaryDiv.style.display = "block";
    
  }

  return retVal;
}

export function validateStringType(value, type): boolean {
  //console.log('In validateStringType...');
  let retVal: boolean = false;

  switch (type) {
    case 'email':
      retVal = validateEmail(value.trim());
      break;
    default:
      retVal = true;
      break;
  }

  return retVal;
}

export function isValidElement(elementId, type): boolean {
  let retVal: boolean = false;

  let element = document.getElementById(elementId) as HTMLInputElement;
  let errDiv = document.getElementById(element.id + 'ErrMsg') as HTMLDivElement;
  if (validateStringType(element.value.trim(), type)) {
    retVal = true;
    errDiv.innerHTML = '';
  } else {
    retVal = false;
    errDiv.innerHTML = '* invalid value';
  }
  return retVal;
}

export function getAwardNameInitials(awardName, numOfInitials): string {
  var names;
  if (awardName != null) {
    names = awardName.split(' ');
    var limit = Math.min(names.length, numOfInitials);
    var initials = '';

    for (var i = 0; i < limit; i++) {
      if (i == 0) {
        initials = names[i].substring(0, 1).toUpperCase() + '.';
      } else {
        initials = initials + names[i].substring(0, 1).toUpperCase() + '.';
      }
    }

    return initials;
  } else {
    return 'S.A.'; //default lowest award
  }
}

export function getLookupValueById(lookup, id) {
  return lookup.filter(r => id == r.id)[0].value;
}

export function showSaveStatusMessage(serverResult: any) {
  if (serverResult) {
    app.run('show-message', 'saved...👍✌️😎', 10000);
  } else {
    app.run('show-message', 'failed... 👎😨😥', 10000);
  }
}

export function formatPhoneNumber(input) {
  let result = '';
  input.length == 0
    ? (result = '')
    : (result = input.substring(0, 3) + '-' + input.substring(3, 6) + '-' + input.substring(6, 10));
  return result;
}

export function formatTollFreePhoneNumber(input) {
  let result = '';

  input.length == 0
    ? (result = '')
    : input.length == 11
      ? (result =
          input.substring(0, 1) +
          '-' +
          input.substring(1, 4) +
          '-' +
          input.substring(4, 7) +
          '-' +
          input.substring(7, 11))
      : (result = input.substring(0, 3) + '-' + input.substring(3, 6) + '-' + input.substring(6, 10));
  return result;
}
